import React from "react";
import PropTypes from "prop-types";
import { Axis, axisPropsFromTickScale } from "react-d3-axis";
import { scaleLinear } from "d3-scale";
import withStyles from "components/with-styles";
import styles from "./styles/timeline-axis.css.js";
import { pixelsToSeconds, secondsToPixels, AXIS_LEGEND_PERIOD } from "./timeline-utils";

const TimelineAxis = ({ classes, onClick, height = 30, period }) => {
  const width = secondsToPixels(period);
  const scale = scaleLinear()
    .domain([0, period])
    .range([0, width]);

  const numberOfTicks = period / AXIS_LEGEND_PERIOD + 1; // one each AXIS_LEGEND_PERIOD seconds

  return (
    <svg
      onClick={e => onClick(pixelsToSeconds(e.nativeEvent.layerX))}
      className={classes.axis}
      height={height}
      width={width}
    >
      <Axis {...axisPropsFromTickScale(scale, numberOfTicks)} />
    </svg>
  );
};

TimelineAxis.propTypes = {
  /*
   * Altura del eje del timeline
   */
  height: PropTypes.number,
  /*
   * Ancho del eje del timeline
   */
  width: PropTypes.number,
  /*
   * Callback que se llama cuando se hace clic
   */
  onClick: PropTypes.func,
  /*
   * Período que representa el timeline (en segundos)
   */
  period: PropTypes.number,
};

export default withStyles(styles)(TimelineAxis);
